import {Component, ChangeDetectionStrategy, inject} from '@angular/core';
import {Router} from '@angular/router';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {KazSearchComponent} from '../kaz-search/kaz-search.component';

/**
 * Desktop-Teil der Kopfzeile: Suche, Filter-Link und Zeitungslogo.
 * Host ist `display: contents`, damit die Elemente direkt in der Flex-Reihe des Frames liegen.
 */
@Component({
    selector: 'kaz-header-search',
    templateUrl: './kaz-header-search.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FaIconComponent, KazSearchComponent],
    host: {class: 'contents'}
})
export class KazHeaderSearchComponent {
  private _router = inject(Router);

  showFilter() {
    this._router.navigate(['/entry/search']).then();
  }
}
